import type { Routes } from '@angular/router';

export const ROUTE_COSTS_AND_PREFERENCES_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./route-costs-and-preferences.component').then(
        (m) => m.RouteCostsAndPreferencesComponent,
      ),
  },
] as const;
